export const navbarNoSearch = {
  showDesktopSearch: false,
  showMobileSearch: false,
  showMobileHeader: true,
  showBottomNav: true,
  narrowContentWidth: false,
};
